<template>
    <div>
        <v-card elevation="0">
            <v-card-text>
                <div style="position:fixed; right: 20px; top: 120px; z-index: 3;">
                <!--Cart Dialog-->
                    <v-dialog v-model="cartdialog" persistent width="auto">
                        <template v-slot:activator="{on, attrs}">
                            <v-badge bordered color="#d7ae28" :content="count" :value="count" depressed overlap bottom>
                                <v-btn color="#d7ae28" v-bind="attrs" v-on="on" large fab elevation="3" :loading="cartloading"><v-icon color="black" large>mdi-cart-outline</v-icon></v-btn>
                            </v-badge>
                        </template>
                        <v-card>
                            <v-toolbar elevation="0" color="#4297A0" dark dense>
                                <v-toolbar-title><v-icon>mdi-cart</v-icon>&nbsp;Your Cart</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn icon @click="closeDialog" small>
                                    <v-icon>mdi-close-thick</v-icon>
                                </v-btn>
                            </v-toolbar>
                            <v-card-text><br />
                                <ShoppingCartSmall v-if="cartdialog" />
                            </v-card-text>
                        </v-card>
                    </v-dialog>
                <!--End of Cart Dialog-->
                </div>
            </v-card-text>
        </v-card>
        <v-card elevation="0" v-if="tableloading" height="300px" width="100%">
            <v-row justify="center" align="center" class="fill-height">
                <v-col cols="6">
                    <v-progress-linear
                        indeterminate
                        rounded
                        height="6"
                        color="#B2C6C2"
                    ></v-progress-linear>
                </v-col>
            </v-row>
        </v-card>
        <v-card elevation="0" color="#B2C6C2" v-else>
            <v-data-iterator :items="items" :page.sync="page" :search="search" :sort-by="sortBy" :sort-desc="sortDesc" :items-per-page="12">
                <template v-slot:header>
                    <v-toolbar dark color="#004236" class="mb-1">
                        <v-text-field v-model="search" clearable flat solo-inverted hide-details prepend-inner-icon="mdi-magnify" label="Search" dense></v-text-field>&nbsp;
                        <template v-if="$vuetify.breakpoint.mdAndUp">
                            <v-select v-model="sortBy" flat solo-inverted hide-details :items="keys" prepend-inner-icon="mdi-sort" label="Sort by" dense></v-select>
                        </template>
                    </v-toolbar>
                </template>
                <template v-slot:default="props">
                    <v-row class="pa-1 ma-1">
                        <v-col
                            v-for="item in props.items"
                            :key="item.classnbr"
                            cols="12"
                            sm="12"
                            md="6"
                            lg="4"
                        >
                            <v-card width="550px">
                                <v-toolbar elevation="0">
                                    <v-toolbar-title class="subheading font-weight-bold">{{ item.title }}</v-toolbar-title>
                                </v-toolbar>
                                <v-list dense height="350px">
                                    <v-list-item
                                        v-for="(key, index) in filteredKeys"
                                        :key="index"
                                    >
                                        <v-row>
                                            <v-col cols="12" sm="4">
                                                <v-list-item-content :class="{ 'green--text': sortBy === key.value }">
                                                    {{ key.text }}:
                                                </v-list-item-content>
                                            </v-col>
                                            <v-col cols="12" sm="8">
                                                <v-list-item-content
                                                    class="align-end"
                                                    :class="{ 'green--text': sortBy === key.text }"
                                                >
                                                    {{ item[key.value] }}
                                                </v-list-item-content>
                                            </v-col>
                                        </v-row>
                                    </v-list-item>
                                </v-list>
                                <v-card-actions>
                                    <v-btn color="#d7ae28" block @click="viewPosting(item)">View Posting</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                </template>
                <template v-slot:no-data>
                    <v-container style="height: 400px;">
                        <v-row
                            class="fill-height"
                            align-content="center"
                            justify="center"
                        >
                            <v-col
                                class="text-subtitle-1 text-center"
                                cols="12"
                            >
                                No available Postings
                            </v-col>
                        </v-row>
                    </v-container>
                </template>
            </v-data-iterator>
            <v-dialog
                v-model="dialogview"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
            >
                <v-card>
                    <v-toolbar
                        dark
                        color="#004236"
                    >
                        <v-toolbar-title>{{ selectedPosting["subject-resolved"] }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn
                                icon
                                dark
                                @click="dialogview = false"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <ViewPosting v-if="dialogview" :item="selectedPosting" />
                    <v-card-text>
                        <v-row justify="center" align="center">
                            <v-col cols="10">
                                <v-btn v-if="!selectedPosting.inCart" color="#d7ae28" block @click="addToCart(selectedPosting)" dark :disabled="cartbtndisable || adminmode" :loading="addCartloading">Add To Cart</v-btn>
                                <v-btn v-else color="#d7ae28" block disabled>In Cart</v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <br />
                </v-card>
            </v-dialog>
        </v-card>
        <v-snackbar
            v-model="snackbar"
            :color="snackbarcolor"
            :timeout="timeout"
        >
            {{ text }}
        </v-snackbar>
    </div>
</template>
<script>
import ViewPosting from "./ViewPosting.vue"
import ShoppingCartSmall from "./ShoppingCartSmall.vue"

import auth from "../../../js/auth"

export default {
    components: {
        ViewPosting,      
        ShoppingCartSmall
    },
    data () {
      return {
        host: location.hostname.toString(),
        cartbtndisable: false,
        tableloading: false,
        search: '',
        filter: {},
        sortDesc: true,
        page: 1,
        sortBy: 'postingstarttimestamp',
        keys: [
            {"text": "Term", "value": "term"},
            {"text": "Discipline", "value": "subject-resolved"},
            {"text": "Type", "value": "type"},
            {"text": "Course(s)", "value": "coursesText"},
            {"text": "Section(s)", "value": "sectionsText"},
            {"text": "Format", "value": "classformat"},
            {"text": "Posted at", "value": "startDate"},
            {"text": "Apply by", "value": "endDate"}
        ],
        items: [],
        cartDiscipline: "",
        dialogview: false,
        dialogadd: false,
        selectedPosting: {},
        snackbar: false,
        snackbarcolor: "",
        text: "",
        timeout: 3500,
        cartdialog: false,
        count: 0,
        cartloading: false,
        addCartloading: false,
        selectedItem: {},
        adminmode: false
      }
    },
    computed: {
        filteredKeys () {
            return this.keys
        },
    },
    methods: {
        initialize(){
            const that = this;

            //Session Reading
            if(sessionStorage.getItem('cupeapp_aaa')){
                that.adminmode = true;
            }else {
                that.adminmode = false;
            }
        },
        getCart(){
            const that= this;
            that.cartloading = true;
            that.count = 0;
            //Session Reading
            let uid = "";
            if(sessionStorage.getItem('cupeapp_aaa')){
                uid = auth.get_impersonated_user()["uid"];
                
            }else {
                uid = auth.get_user()["uid"];
            }

            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=getrawcart&data={"uid": "'+uid+'"}';

            //API calling
            fetch(api)
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/^OK/i)){
                        that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                    }else {
                        if(resultData.data.length == 0){
                            that.count = 0;
                        }else {
                            if(resultData.data[0].hasOwnProperty("cartData")){
                                that.items.forEach(element => {
                                    resultData.data[0].cartData.forEach(e => {
                                        if(element["id"] == e["postingid"]){
                                            element["inCart"] = true;
                                        }
                                    });
                                });

                                if(resultData.data[0].cartData.length > 0){
                                    that.cartDiscipline = resultData.data[0].cartData[0]["discipline"];
                                    that.count = resultData.data[0].cartData.length;
                                }
                            }else {
                                that.count = 0;
                            }
                        }
                    }
                    that.cartloading = false;
                })
                .catch(function(err){
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                })
            //End of API calling
        },
        loadPostings(){
            const that = this;

            //Session Reading
            let user = "";
            if(sessionStorage.getItem('cupeapp_aaa')){
                user = auth.get_impersonated_user();
                that.cartbtndisable = true;
            }else {
                user = auth.get_user();
                that.cartbtndisable = false;
            }

            that.tableloading = true;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=postingsget';

            //API calling
            fetch(api)
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/^OK/i)){
                        that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                    }else {
                        that.items = resultData.data;

                        that.modifyData();
                        that.tableloading = false;
                    }
                })
                .catch(function(err){
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                })
            //End of API calling
        },
        modifyData(){
            const that = this;

            that.items.forEach(element => {   
                //Courses
                var courselist = "";
                var sections = "";
                var format = "";
                element["courses"].forEach(e => {
                    if(e["ssrcomponent"] == "LEC"){
                        courselist += e["catalognbr"]+", ";
                        sections += e["classsection"]+", ";
                        format += e["classformat"]+", ";
                    }
                });
                
                element["term"] = that.resolveTerm(element["strm"]);
                element["department"] = element["courses"][0]["academicdepartment"];
                element["coursesText"] = courselist.slice(0,-2);
                element["sectionsText"] = sections.slice(0,-2);
                element["subject-resolved"] = element["courses"][0]["subject-resolved"];
                element["postingstarttimestamp"] = Date.parse(element["startDate"]);
                element["inCart"] = false;
                element["classformat"] = format.slice(0,-2);
            });
        },
        resolveTerm(stream){
            const that = this;
            let term = stream.slice(-1);
            var year = stream[1]+stream[2];
            var year2 = (parseInt(year)+1).toString();
            var century = (parseInt(stream[0])-1).toString();
            if(term == "9"){
                return "FALL 2"+century+year+"/WINTER 2"+century+year2;
            }else if(term == "5"){
                return "SUMMER 2"+century+year;
            }
        },
        viewPosting(item){
            const that = this;

            that.selectedPosting = item;
            that.dialogview = true;
        },
        addToCart(item){
            const that= this;
            that.selectedItem = item;

            if(that.count > 0 && item["discipline"].toLowerCase() != that.cartDiscipline.toLowerCase()){
                that.setSnackbar("Cannot add postings from different discipline to the cart - current discipline in cart: "+that.cartDiscipline, "orange");
            }else {
                let api= 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py';
                that.addCartloading = true;
                //Session Reading
                let uid = "";
                if(sessionStorage.getItem('cupeapp_aaa')){
                    uid = auth.get_impersonated_user()["uid"];
                    
                }else {
                    uid = auth.get_user()["uid"];
                }
                
                const formData = new FormData();
                formData.append("mode", "updateCart");
                formData.append("data", JSON.stringify({
                    "uid": uid,
                    "postingid": item["id"]
                }));

                fetch(api, {
                    method: 'POST',
                    body: formData
                })
                .then(function(response){
                    return response.json();
                })
                .then(function (data) {
                    if(data.result.match(/ok/i)){
                        that.items.forEach(element => {
                            if(element["id"] == item["id"]){
                                element["inCart"] = true;
                            }
                        });

                        that.count = that.count+1;
                        that.cartDiscipline = item["discipline"];
                    }else {
                        that.setSnackbar("Warning: "+data.message.toString(), "orange");
                    }

                    that.addCartloading = false;
                })
                .catch(function (err) {
                    that.setSnackbar("Error occurred : "+err.toString(), "red");
                })
            }
        },
        closeDialog(){
            const that = this;

            that.loadPostings();
            that.getCart();
            that.cartdialog = false;
        },
        setSnackbar(msg, color){ //Sets Snackbar
            const that = this;
            that.snackbar = true;
            that.snackbarcolor = color;
            that.text = msg;
        }
    },
    created(){
        const that = this;
        that.initialize();
        that.loadPostings();
        that.getCart();
    }
}
</script>